import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Cart } from 'src/app/stores/checkout.store';
import { currencyCode, imageUrl } from 'src/environments/environment';

@Component({
  selector: 'app-select-product',
  templateUrl: './select-product.component.html',
  styleUrls: ['./select-product.component.scss'],
})
export class SelectProductComponent implements OnInit {
  @Input() cartIndex: number;
  @Input() selectproducts: any;
  imageUrl = imageUrl;
  currencyCode = currencyCode;
  constructor(
    public platform:Platform
  ) {}

  ngOnInit() {}
}
